// === Employee Profile Types ===

export interface EmployeeProfile {
  id: string;
  name: string;
  initials: string;
  email: string;
  phone: string;
  avatarColor: string; // tailwind gradient class
  avatarUrl: string | null;
  jobTitle: string;
  department: string;
  team: string;
  leaderTeamName?: string | null; // team name derived from the employee's line manager (reports_to)
  location: string;
  company: string;
  status: "Active" | "Disabled" | "On Leave" | "Left the Company";
  accessMode: "full" | "limited" | "disabled";
  startDate: string; // ISO date string
  reportsTo: { id: string; name: string; initials: string; avatarColor: string; avatarUrl: string | null } | null;
  mainRole?: string | null;
  subRole?: string | null;
  isLineManager: boolean;
  fullProfileAccess: boolean;
  employeeId: string; // e.g. "EMP-0042"
  contractType: "Full-time" | "Part-time" | "Contract" | "Intern";
  workSchedule: string;
  birthday: string; // "Mar 15"
  nationality: string;
  gender: string;
  address: string;
  positionId: number | null;
  positionTitle: string | null;
}

// Helper: calculate tenure from startDate
export function calcTenure(startDate: string): string {
  const start = new Date(startDate);
  const now = new Date();
  let years = now.getFullYear() - start.getFullYear();
  let months = now.getMonth() - start.getMonth();
  if (months < 0) {
    years--;
    months += 12;
  }
  const parts: string[] = [];
  if (years > 0) parts.push(`${years}y`);
  if (months > 0) parts.push(`${months}m`);
  return parts.length > 0 ? parts.join(" ") : "< 1m";
}

// Helper: format start date for display
export function formatStartDate(startDate: string): string {
  return new Date(startDate).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
